// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.0043 0.589966L2.00015 0.585815L0.585938 2.00003L2.58594 4.00003L0.0859375 6.50003L1.50015 7.91424L4.00015 5.41424L4.72499 6.13908C3.03566 7.92975 2.00015 10.344 2.00015 13C2.00015 18.5229 6.4773 23 12.0002 23C14.6562 23 17.0704 21.9645 18.8611 20.2752L22.0002 23.4142L23.4101 22.0043L2 0.594267L2.0043 0.589966Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.1881 16.9539C21.7107 15.7412 22.0002 14.4044 22.0002 13C22.0002 7.47718 17.523 3.00003 12.0002 3.00003C10.5958 3.00003 9.259 3.28953 8.04627 3.81211L21.1881 16.9539Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.5002 1.08582L23.9144 6.50003L22.5002 7.91424L17.0859 2.50003L18.5002 1.08582Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-alarm-off-filled')
export default class AlarmOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'alarm-off-filled',
    }
  }
}
